import { PageItemProps } from "apis";
import { lazy } from "react";

export const PageAdminPageBuilder = lazy(() => import("./builder/"));
export const PageAdminPageBuilderView = lazy(() => import("./builder/View"));
export const PageAdminPageBuilderView_V2 = lazy(() => import("./builder/View_V2"));

export const PageAdminPageBuilderTest = lazy(() => import("./builder/Test"));

export const PageAdminPage = lazy(() => import("./List"));
export const PageAdminPageCreate = lazy(() => import("./Add"));
export const PageAdminPageUpdate = lazy(() => import("./Edit"));

export interface FormPageValuesProps extends PageItemProps { }